import { render, staticRenderFns } from "./InstagramCard.vue?vue&type=template&id=a696f3b4&scoped=true&"
import script from "./InstagramCard.vue?vue&type=script&lang=js&"
export * from "./InstagramCard.vue?vue&type=script&lang=js&"
import style0 from "./InstagramCard.vue?vue&type=style&index=0&id=a696f3b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a696f3b4",
  null
  
)

export default component.exports